//
// Functions for logging
//

/**
 * Formats debug
 *
 * @param {*} handle
 * @param {*} data
 * @param {*} label
 * @param {*} color
 */
export function log(handle, data, label, color) {
  return;
  if (color != undefined) {
    const stringData = typeof data === 'string' ? data : '';
    label = stringData ? `${label}:` : label;
    console.groupCollapsed('%c%s %s %s', `color:${color}; font-weight: bold;`, `[${handle}]`, label, stringData);
    console.log(data);
    console.groupEnd();
  } else if (label) {
    console.log(`[${handle}]`, label, data);
  }
}

/**
 * Log errors (currently just to console)
 *
 * @param {*} data
 * @param {*} label
 */
export function logError(data, label) {
  // @TODO post to some error reporting?
  const handle = 'Error';
  log(handle, data, label, 'Crimson');
}

/**
 * Log info (currently just to console)
 *
 * @param {*} data
 * @param {*} label
 */
export function logInfo(data, label) {
  // @TODO post to some tracking?
  const handle = 'Info';
  log(handle, data, label, 'DodgerBlue');
}
